import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import BlogPostViewer from '../components/BlogPostViewer';
import SEO from '@/components/SEO';
import { getBlogPostById } from '../utils/blogConfig';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import Footer from '@/components/Footer';

const BlogPostPage: React.FC = () => {
  const { blogId } = useParams<{ blogId: string }>();
  const navigate = useNavigate();
  const [seoData, setSeoData] = useState<any>(null);

  const handleBackToList = () => {
    navigate('/top-5-news');
  };

  if (!blogId) {
    return (
      <div className="min-h-screen bg-black">
        <div className="fixed top-0 left-0 right-0 z-50 text-white">
          <Navbar />
        </div>
        <div className="container mx-auto pt-24 px-4">
          <div className="text-white">Blog ID not found</div>
        </div>
      </div>
    );
  }

  const blogPost = getBlogPostById(blogId);

  if (!blogPost) {
    return (
      <div className="min-h-screen bg-black">
        <div className="fixed top-0 left-0 right-0 z-50 text-white">
          <Navbar />
        </div>
        <div className="container mx-auto pt-24 px-4">
          <div className="text-white">
            <h1 className="text-2xl font-bold mb-4">Blog Post Not Found</h1>
            <Button
              variant="ghost"
              onClick={handleBackToList}
              className="text-wealth-white hover:text-wealth-white/80 flex items-center gap-2 px-0 hover:bg-transparent"
            >
              <ArrowLeft className="h-5 w-5" />
              Back to Blog List
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      {seoData && (
        <SEO 
          overrideSEO={{
            title: seoData.title,
            description: seoData.description,
            keywords: seoData.tags,
            image: seoData.headlineImage,
          }}
        />
      )}
      <div className="fixed top-0 left-0 right-0 z-50 text-white">
        <Navbar />
      </div>
     
      <div className="container mx-auto pt-24 px-4 pb-16">
        <Button
          variant="ghost"
          onClick={handleBackToList}
          className="mb-6 text-wealth-white hover:text-wealth-white/80 flex items-center gap-2 px-0 hover:bg-transparent"
        >
          <ArrowLeft className="h-5 w-5" />
          Back
        </Button>
        
        {/* Back floating button */}
        <div className="fixed left-2 top-24 z-40 md:left-4"> 
          <Button
            onClick={handleBackToList}
            className="rounded-full bg-[#9E7C47] hover:bg-[#9E7C47]/90 text-white shadow-lg hover:shadow-xl transition-all duration-300 p-3 md:p-4"
            aria-label="Back to blog list"
          >
            <ArrowLeft className="h-5 w-5 md:h-6 md:w-6" strokeWidth={3.5} />
          </Button>
        </div>
        
        <BlogPostViewer 
          blogPost={blogPost} 
          onSEODataExtracted={setSeoData}
        />
      </div>
      
      <div className="text-white">
        <Footer />
      </div>
    </div>
  );
};

export default BlogPostPage;